{ createStore, applyMiddleware } = require 'redux'
Reducer = require './Reducer'
LoggerMiddleware = require './LoggerMiddleware'
RedrawMiddleware = require './RedrawMiddleware'
StorageMiddleware = require './StorageMiddleware'

module.exports = (initialState) ->
	createStore(
		Reducer,
		initialState,
		applyMiddleware LoggerMiddleware, RedrawMiddleware, StorageMiddleware
	)